<template>
  <div class="container">
    <content-header :data="[{text:'资料一览', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
          <el-button type="primary" icon="plus" @click="initNewHandle">添加</el-button>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="关键词"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="id"
            label="ID"
            width="100"
            fixed>
          </el-table-column>
          <el-table-column
            prop="name"
            label="名称">
          </el-table-column>
          <el-table-column
            label="封面图">
            <template slot-scope="scope">
            <img style="width:40px;height:40px":src="domainPic + scope.row.cover_url" v-if="scope.row.cover_url"/>
            </template>
          </el-table-column>
          <el-table-column
            prop="full_file_url"
            label="资源链接"
            width="150">
          </el-table-column>
          <el-table-column
            prop="category_name"
            label="分类"
            width="150">
          </el-table-column>
          <el-table-column
            label="资源类型">
            <template slot-scope="scope">
              <span>{{scope.row.type==1?'视频':'文档'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="description"
            label="描述">
          </el-table-column>
          <el-table-column
            prop="list_order"
            label="排序">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="150">
            <template slot-scope="scope">
              <el-button @click="initEditHandle(scope)" type="text" size="small" >修改</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > pageSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 新建弹出区域 -->
      <div class="new-wrap">
        <el-dialog :title="curObj.id ? '修改资料' : '添加资料'" :visible.sync="isObjShow">
          <el-form :model="curObj" :rules="curObjRules" ref="curObjForm" label-position="right" label-width="0px">
            <el-form-item prop="name" label="名称" :label-width="formLabelWidth">
              <el-input name="name" v-model="curObj.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="category_id" label="分类" :label-width="formLabelWidth">
              <el-select v-model="curObj.category_id" clearable value-key="id" placeholder="请选择分类">
                <el-option
                  v-for="item in categoryIds"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="cover_url" label="封面图片" :label-width="formLabelWidth">
              <el-upload
                class="avatar-uploader"
                :headers = "uploadHeader"
                :action="uploadUrl"
                :show-file-list="false"
                :on-success="uploadPhotoSuccess"
                :before-upload="beforePhotoUpload"
                :on-error="uploadError">
                <img v-if="curObj.cover_url" :src="domainPic + curObj.cover_url" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item prop="type" label="资源类型" :label-width="formLabelWidth">
              <el-select v-model="curObj.type" clearable value-key="id" placeholder="请选择类型">
                <el-option
                  v-for="item in typeIds"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="file_url" label="资源文件链接" :label-width="formLabelWidth">
              <el-input name="file_url" v-model="curObj.file_url" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="description" label="描述" :label-width="formLabelWidth">
              <el-input type="textarea" name="description" v-model="curObj.description" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="list_order" label="排序" :label-width="formLabelWidth">
              <el-input name="list_order" v-model="curObj.list_order" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isObjShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import sessionstorage from 'utils/sessionstorage'
  import urls from 'config/urls'
  import ResourceModel from 'models/resource'

  export default {
    components: {
    },
    data () {
      return {
        domainPic: constants.basic.domain_pic,
        uploadUrl: constants.basic.domain + urls.file.upload,
        uploadHeader: {},
        keywords: '',
        tableData: [],
        isObjShow: false,
        categoryIds: [],
        typeIds: [{id: 1, name: '视频'}, {id: 2, name: '文档(pdf)'}],
        curObj: {
          id: '',
          name: '',
          category_id: '',
          cover_url: '',
          file_url: '',
          type: 2,
          description: '',
          list_order: 0
        },
        formLabelWidth: '120px',
        curObjRules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          category_id: [{ required: true, message: '请选择分类', trigger: 'blur' }],
          cover_url: [{ required: true, message: '请上传封面图', trigger: 'blur' }],
          file_url: [{ required: true, message: '请输入资源链接URL', trigger: 'blur' }],
        },
        curPage: 1,
        pageSize: 10,
        total: 0
      }
    },
    created () {
      sessionstorage.getItem('token').then(token => {
        if (!token) return
        this.uploadHeader = {Authorization: 'Bearer ' + token}
      })
      ResourceModel.findCategory({curPage: 1, pageSize: 1000}).then(res => {
        this.categoryIds = res.item_list
      })
      //
      this.getObjList()
    },
    methods: {
      uploadError (err, file, fileList) {
        console.log(err)
      },
      uploadPhotoSuccess (response, file, fileList) {
        this.curObj.cover_url = response
      },
      beforePhotoUpload (file) {
        const isPic = (file.type === 'image/jpeg' || file.type === 'image/png')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isPic) {
          this.$message.error('上传图片只能是 JPG/PNG 格式!')
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!')
        }
        return isPic && isLt2M
      },
      pageSizeChange (size) {
        this.pageSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.pageSize,
          keywords: this.keywords
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        console.log(_opts)
        //
        ResourceModel.find(_opts).then(res => {
          this.tableData = res.item_list
          this.total = res.total
        })
      },
      //
      deleteHandle (item) {
        this.$confirm('是否确认删除？')
          .then(_ => {
            ResourceModel.delete({
              id: item.row.id,
            }).then(() => {
              this.tableData.splice(item.$index, 1)
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
          })
          .catch(_ => {})
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      initNewHandle () {
        this.curObj = {
          id: '',
          name: '',
          category_id: '',
          cover_url: '',
          file_url: '',
          type: 2,
          description: '',
          list_order: 0
        }
        this.isObjShow = true
      },
      newHandle () {
        ResourceModel.create(this.curObj).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      initEditHandle (item) {
        this.curObj = {
          id: item.row.id,
          name: item.row.name,
          category_id: item.row.category_id,
          cover_url: item.row.cover_url,
          file_url: item.row.file_url,
          type: item.row.type,
          description: item.row.description,
          list_order: item.row.list_order
        }
        this.isObjShow = true
      },
      editHandle () {
        ResourceModel.update(this.curObj).then(() => {
          this.getObjList()
          this.isObjShow = false
          this.$message({ message: '更新成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      searchHandle () {
        this.curPage = 1
        this.getObjList()
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 10px
        margin-bottom: 10px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
    .avatar-uploader
        border: 1px dashed #d9d9d9
        border-radius: 6px
        cursor: pointer
        position: relative
        overflow: hidden
        width: 180px
        &:hover
          border-color: #409EFF
        .avatar-uploader-icon
          font-size: 28px
          color: #8c939d
          width: 178px
          height: 178px
          line-height: 178px
          text-align: center
        .avatar
          width: 178px
          height: 178px
          display: block

</style>



// WEBPACK FOOTER //
// src/views/Resource.vue